import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "احسب السعرات الحرارية التي تحرقها أثناء المشي";
const DESCRIPTION = "حاسبة دقيقة لتقدير السعرات الحرارية المحروقة بناءً على عدد الخطوات والوزن والطول وسرعة المشي";
const KEYWORDS = "حاسبة السعرات, حاسبة الخطوات, حرق السعرات, المشي, اللياقة البدنية";
const OG_URL = "https://do-calculate.com/calculator/ar/steps-to-calories/";
function StepsToCaloriesCalculator() {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [steps, setSteps] = useState("");
    const [speed, setSpeed] = useState("average");
    const [result, setResult] = useState(null);
    const [error, setError] = useState("");
    const calculateCalories = () => {
        try {
            setError("");
            if (!weight || !height || !steps) {
                throw new Error("الرجاء إدخال جميع القيم المطلوبة");
            }
            const weightKg = parseFloat(weight);
            const heightM = parseFloat(height) / 100;
            const stepsCount = parseFloat(steps);
            if (weightKg <= 0 || heightM <= 0 || stepsCount <= 0) {
                throw new Error("يجب أن تكون القيم أكبر من الصفر");
            }
            let met;
            let pace;
            switch (speed) {
                case "slow":
                    met = 2.8;
                    pace = 0.9;
                    break;
                case "average":
                    met = 3.5;
                    pace = 1.34;
                    break;
                case "fast":
                    met = 5.0;
                    pace = 1.79;
                    break;
                default:
                    met = 3.5;
                    pace = 1.34;
            }
            const stride = heightM * 0.414;
            const distance = stride * stepsCount;
            const time = distance / pace;
            const caloriesBurned = time * met * 3.5 * weightKg / (200 * 60);
            const caloriesPerStep = caloriesBurned / stepsCount;
            setResult({
                caloriesBurned: caloriesBurned.toFixed(2),
                caloriesPerStep: caloriesPerStep.toFixed(5),
                distance: (distance / 1000).toFixed(2)
            });
        } catch (error) {
            setError(error.message);
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: "50px" }}>
                        <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>تقوم هذه الحاسبة بتقدير السعرات الحرارية التي تحرقها أثناء المشي بناءً على عدد الخطوات التي تقوم بها.</p>
                                <p>
                                    المشي هو التمرين الرياضي الأكثر بساطة كونه لا يتطلب أي معدات خاصة، ولا يتعين عليك الدفع مقابل عضوية الصالة الرياضية باهظة الثمن، ويمكنك القيام بذلك في أي مكان.
                                </p>
                                <p>لحساب السعرات الحرارية المحروقة، نستخدم المعادلة التالية:</p>
                                <ul>
                                    <li>نأخذ في الاعتبار وزنك وطولك وسرعة مشيك</li>
                                    <li>نحسب معدل الأيض (MET) بناءً على سرعة المشي</li>
                                    <li>نطبق معادلة علمية تربط بين الخطوات والسعرات الحرارية</li>
                                </ul>
                                <p>تم تطوير هذه الحاسبة بناءً على دراسات علمية في مجال التمثيل الغذائي والنشاط البدني.</p>
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds/>
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white">
                                    <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                                </div>
                                <div dir="rtl">
                                    <div>
                                        <hr />
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="weight">
                                                الوزن (كجم)
                                            </label>
                                            <input
                                                id="weight"
                                                type="number"
                                                value={weight}
                                                onChange={(e) => setWeight(e.target.value)}
                                                placeholder="أدخل وزنك بالكيلوجرام"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="height">
                                                الطول (سم)
                                            </label>
                                            <input
                                                id="height"
                                                type="number"
                                                value={height}
                                                onChange={(e) => setHeight(e.target.value)}
                                                placeholder="أدخل طولك بالسنتيمتر"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="steps">
                                                عدد الخطوات
                                            </label>
                                            <input
                                                id="steps"
                                                type="number"
                                                value={steps}
                                                onChange={(e) => setSteps(e.target.value)}
                                                placeholder="أدخل عدد الخطوات"
                                                className="form-control"
                                                style={{ width: "75%" }}
                                                min="1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label className="form-label ms-2" htmlFor="speed">
                                                سرعة المشي
                                            </label>
                                            <select
                                                id="speed"
                                                value={speed}
                                                onChange={(e) => setSpeed(e.target.value)}
                                                className="form-control"
                                                style={{ width: "75%" }}
                                            >
                                                <option value="slow">بطيء (3.2 كم/ساعة - 0.9 م/ث)</option>
                                                <option value="average">متوسط (5 كم/ساعة - 1.34 م/ث)</option>
                                                <option value="fast">سريع (6.5 كم/ساعة - 1.79 م/ث)</option>
                                            </select>
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: "20px", marginLeft: "10px" }}
                                            onClick={calculateCalories}
                                        >
                                            احسب                                        </button>
                                    </div>
                                    <br />
                                    { error !== "" && (
                                        <p className="p-3 mb-2 bg-warning text-black">
                                            خطأ: {error}
                                        </p>
                                    )}
                                    {result &&  (
                                        <div className="p-3 mb-2 bg-success text-white">
                                            <h4>النتائج:</h4>
                                            <p className="text-white">المسافة المقطوعة: {result.distance} كم</p>
                                            <p className="text-white">السعرات الحرارية المحروقة: {result.caloriesBurned} سعرة حرارية</p>
                                            <p className="text-white">السعرات الحرارية لكل خطوة: {result.caloriesPerStep} سعرة حرارية</p>
                                        </div>
                                    )}
                                    <hr />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: "auto" }}>
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">معلومات عن الحاسبة</div>
                            <div className="info-section-body">
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>كيف تعمل هذه الحاسبة؟</h2>
                                    </u>
                                    <p>تقوم الحاسبة بتقدير السعرات الحرارية المحروقة بناءً على عدة عوامل:</p>
                                    <ul>
                                        <li>الوزن: كلما زاد وزنك، زادت السعرات التي تحرقها</li>
                                        <li>الطول: يؤثر طولك على طول خطوتك وبالتالي عدد الخطوات</li>
                                        <li>عدد الخطوات: المقياس الأساسي للنشاط البدني</li>
                                        <li>سرعة المشي: تؤثر السرعة على شدة النشاط ومعدل الحرق</li>
                                    </ul>
                                    <hr />
                                    <div>
                                        <p>نستخدم المعادلة العلمية الدقيقة التالية:</p>
                                        <ol>
                                            <li>حساب طول الخطوة: الطول (متر) × 0.414</li>
                                            <li>حساب المسافة المقطوعة: طول الخطوة × عدد الخطوات</li>
                                            <li>حساب وقت المشي: المسافة / السرعة</li>
                                            <li>حساب السعرات الحرارية: الوقت × MET × 3.5 × الوزن / (200 × 60)</li>
                                        </ol>
                                        <p>حيث:</p>
                                        <ul>
                                            <li>MET: يعتمد على سرعة المشي (بطيء: 2.8، متوسط: 3.5، سريع: 5.0)</li>
                                            <li>السرعة: بطيء (0.9 م/ث)، متوسط (1.34 م/ث)، سريع (1.79 م/ث)</li>
                                        </ul>
                                        <hr />
                                    </div>
                                    <br />
                                    <div className="p-3 mb-2 bg-info">
                                        مثال: شخص وزنه 70 كجم، طوله 170 سم، يمشي 10000 خطوة بسرعة متوسطة
                                        سيحرق حوالي 400 سعرة حرارية.
                                    </div>
                                    <br />
                                </div>
                                <hr />
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>نصائح لزيادة حرق السعرات</h2>
                                    </u>
                                    <ul>
                                        <li>حاول زيادة عدد خطواتك اليومية تدريجياً</li>
                                        <li>اختر مسارات بها بعض المرتفعات لزيادة المجهود</li>
                                        <li>زود سرعة مشيك بشكل تدريجي</li>
                                        <li>استخدم عداد الخطوات لتتبع تقدمك</li>
                                    </ul>
                                    <p>
                                        وتقول خبيرة اللياقة البدنية دينيس أوستن: "المشي هو أحد أسرع الطرق وأسهلها لحرق السعرات الحرارية، لأنه يمكنك القيام به في أي وقت ومكان، حتى داخل منزلك".
                                    </p>
                                    <p>
                                        ويقول تيموثي بورنيت، مدرس علم الحركة في جامعة ولاية أوريغون كاسكيدز: "التقدير السريع لعدد السعرات الحرارية التي يحرقها الشخص العادي من خلال المشي هو 100 سعرة حرارية لكل ميل، وهذا سواء كنت تجري أو تقوم بنزهة ممتعة".
                                        وببساطة كلما زادت السرعة، قلّ الوقت الذي ستحتاجه لحرق نفس القدر من السعرات الحرارية.
                                    </p>
                                    <hr />
                                </div>
                                <div>
                                    <u>
                                        <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>
                                    </u>
                                    <p><strong>هل هذه الحاسبة دقيقة؟</strong></p>
                                    <p>النتائج تقديرية وقد تختلف قليلاً حسب الفرد، لكنها تعطي صورة تقريبية جيدة.</p>
                                    <p><strong>لماذا يؤثر الطول على الحساب؟</strong></p>
                                    <p>لأن الأشخاص الأطول لديهم خطوات أطول، وبالتالي يقطعون مسافة أكبر بنفس عدد الخطوات.</p>
                                    <p><strong>كيف يمكنني زيادة دقة الحساب؟</strong></p>
                                    <p>استخدم عداد خطوات موثوقاً به، وقياس وزنك وطولك بدقة.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    );
}
export default StepsToCaloriesCalculator;